var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Grid',{ref:"gridEl",attrs:{"row-data":_vm.releaseNotes,"column-defs":_vm.columnDefs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }